<div class="product-page">
  <div class="product-page__nav">
    <app-category-nav [selectedSlug]="product()?.categorySlug || undefined" />
  </div>

  <div class="product-page__content">

  <!-- Loading skeleton -->
  @if (loading()) {
    <div class="product-page__skeleton">
      <div class="skeleton-img"></div>
      <div class="skeleton-info">
        <div class="skeleton-line skeleton-line--lg"></div>
        <div class="skeleton-line skeleton-line--sm"></div>
        <div class="skeleton-line skeleton-line--md"></div>
        <div class="skeleton-line skeleton-line--md"></div>
      </div>
    </div>
  }

  <!-- Error state -->
  @if (error()) {
    <div class="product-page__error">
      <p>Товар не знайдено</p>
      <a class="product-page__back-btn" routerLink="/">← Повернутися до каталогу</a>
    </div>
  }

  <!-- Product -->
  @if (!loading() && !error() && product(); as p) {
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a class="breadcrumb__link" routerLink="/">Головна</a>
      <span class="breadcrumb__sep">›</span>
      @if (p.categorySlug) {
        <a class="breadcrumb__link" [routerLink]="['/']" [queryParams]="{ category: p.categorySlug }">{{ p.categoryName }}</a>
        <span class="breadcrumb__sep">›</span>
      }
      <span class="breadcrumb__current">{{ p.name }}</span>
    </nav>

    <div class="product-layout">

      <!-- ── Gallery ─────────────────────────────────────────────────── -->
      <div class="gallery">
        <div class="gallery__main">
          @if (p.imageUrls.length > 0) {
            <img
              class="gallery__main-img"
              [src]="p.imageUrls[activeImage()]"
              [alt]="p.name"
            />
          } @else {
            <div class="gallery__placeholder">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="64" height="64" opacity="0.2">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
            </div>
          }
        </div>

        @if (p.imageUrls.length > 1) {
          <div class="gallery__thumbs">
            @for (url of p.imageUrls; track url; let i = $index) {
              <button
                class="gallery__thumb"
                [class.gallery__thumb--active]="activeImage() === i"
                (click)="activeImage.set(i)"
                type="button"
              >
                <img [src]="url" [alt]="p.name + ' ' + (i + 1)" />
              </button>
            }
          </div>
        }
      </div>

      <!-- ── Info ────────────────────────────────────────────────────── -->
      <div class="info">
        @if (p.sku) {
          <p class="info__sku">Артикул: {{ p.sku }}</p>
        }
        <h1 class="info__name">{{ p.name }}</h1>

        @if (p.weightLabel) {
          <div class="info__section">
            <p class="info__label">Вага</p>
            <p class="info__meta">{{ p.weightLabel }}</p>
          </div>
        }

        @if (p.package) {
          <div class="info__section">
            <p class="info__label">Упаковка</p>
            <p class="info__meta">{{ p.package }}</p>
          </div>
        }

        <!-- Price -->
        <div class="info__price-row">
          @if (activePrice != null) {
            <span class="info__price">{{ activePrice | number:'1.2-2' }} грн</span>
          } @else {
            <span class="info__price info__price--na">Ціна за запитом</span>
          }
          @if (p.wholesalePrice != null) {
            <span class="info__wholesale">Опт: {{ p.wholesalePrice | number:'1.2-2' }} грн</span>
          }
        </div>

        <!-- Add to cart -->
        @if (cartQty() > 0) {
          <p class="info__in-cart">У кошику: {{ cartQty() }} шт.</p>
        }
        <div class="info__actions">
          <div class="info__qty-group">
            <span class="info__qty-label">Кількість</span>
            <div class="info__qty" [class.info__qty--in-cart]="cartQty() > 0">
              <button class="info__qty-btn" type="button" (click)="changeQty(-1)">−</button>
              <span class="info__qty-val">{{ displayQty() }}</span>
              <button class="info__qty-btn" type="button" (click)="changeQty(1)">+</button>
            </div>
          </div>
          <button
            class="info__cart-btn"
            [class.info__cart-btn--added]="addedToCart() || cartQty() > 0"
            type="button"
            [disabled]="cartQty() > 0"
            (click)="addToCart()"
          >
            @if (cartQty() > 0 || addedToCart()) {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              {{ cartQty() > 0 ? 'У кошику' : 'Додано!' }}
            } @else {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
              </svg>
              До кошика
            }
          </button>
        </div>

        <!-- Characteristics -->
        @if (p.characteristicsHtml) {
          <div class="info__section">
            <p class="info__label">Характеристики</p>
            <div class="info__richtext" [innerHTML]="p.characteristicsHtml"></div>
          </div>
        }
      </div>
    </div>

    <!-- Description -->
    @if (p.descriptionHtml) {
      <section class="description">
        <h2 class="description__title">Опис</h2>
        <div class="description__body" [innerHTML]="p.descriptionHtml"></div>
      </section>
    }
  }

  </div>
</div>
